import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CloseButtonModule } from '@shared/components/close-button';
import { ButtonModule } from '@features/forms/button';

import { ConfirmationOverlayComponent } from './components/confirmation-overlay/confirmation-overlay.component';
import { InformationOverlayComponent } from './components/information-overlay/information-overlay.component';
import { NewsOverlayComponent } from './components/news-overlay/news-overlay.component';
import { SwitchOverlayComponent } from './components/switch-overlay/switch-overlay.component';

import { IconModule } from '@app/shared/components/icon';

import { RouterModule } from '@angular/router';

@NgModule({
  exports: [SwitchOverlayComponent, ConfirmationOverlayComponent, NewsOverlayComponent],
  imports: [
    CommonModule,
    A11yModule,
    ButtonModule,
    CloseButtonModule,
    IconModule,
    RouterModule,
    SwitchOverlayComponent,
    ConfirmationOverlayComponent,
    InformationOverlayComponent,
    NewsOverlayComponent,
  ],
})
export class OverlayModule {}
